import React from "react";
import { Toolbar, IconButton, Typography, Grid } from "@material-ui/core";
import { Menu } from '../ui-components/Icons';
import { Contacts, Home, Drafts, SentPosts, Categories, Chat, NewPost, Reservations, Rooms, Reminders, Trainers, Subscriptions, Activities } from './TopBarSections';
import Button from "../ui-components/Button/Button";
import { UserStatsComponent } from "./UserStatsComponent";

interface IProps {
    classes: any;
    currentMenuSelection: string;
    handleDrawerOpen: () => void;
    restNewMessageReceivedStatus: () => void;
    newMessageReceived: boolean;
}
const topBarComponent = (currentMenuSelection: string) => {
    // console.log("topBarComponent", currentMenuSelection);
    switch (currentMenuSelection) {
        case '':
            return <Home />
        case 'Reminders':
            return <Reminders />
        case 'Trainers':
            return <Trainers />
        case 'Activities':
            return <Activities />
        case 'Subscriptions':
            return <Subscriptions />
        case 'Contacts':
            return <Contacts />
        case 'drafts':
            return <Drafts />
        case 'sent':
            return <SentPosts />
        case 'Tags':
            return <Categories />
        case 'Chat':
            return <Chat />
        case 'new':
            return <NewPost />
        case 'Room':
            return <Rooms />
        case 'ActivityReservations':
        case 'Reservation':
            return <Reservations menu={currentMenuSelection} />
        default:
            return <Home />
    }
}

export const TopBar = (props: IProps) => {
    return (
        <Toolbar className={props.classes.toolBar}>
            <div className={props.classes.toolBarHeader}>
                <IconButton color="inherit" aria-label="Open drawer" onClick={props.handleDrawerOpen} edge="start" className={props.classes.menuButton}>
                    <Menu />
                </IconButton>
                <Grid container justify="space-between">
                    <Typography variant="h6" noWrap>Gym Admin</Typography>
                    <UserStatsComponent />
                    <div className={props.classes.newMessageReceivedContainer}>
                        {props.newMessageReceived && <Button className={props.classes.newMessageReceivedButton} onClick={() => { props.restNewMessageReceivedStatus() }}>
                            Nuovi messaggi
                        </Button>}
                    </div>
                </Grid>
            </div>
            {topBarComponent(props.currentMenuSelection)}
        </Toolbar>
    );
}